import { observer } from "mobx-react-lite";
import React from "react";
import { YStack } from "tamagui";
import { Subtext } from "../../../ui/Subtext";
import { AvatarSize } from "../../../ui/UserAvatar";
import { UserAvatarGroupRaw } from "../../../ui/UserAvatarGroupRaw";
import type {
  BusinessPlanModel,
  BusinessStaticUserInfoWithUserUid,
} from "../BusinessPlanModel";

export const BusinessTeamInfo = observer(
  ({
    businessPlan,
    userInfo,
  }: {
    businessPlan: BusinessPlanModel;
    userInfo: BusinessStaticUserInfoWithUserUid;
  }) => {
    const planInfo = React.useMemo(() => {
      for (const pInfo of businessPlan.data.teamsInfo) {
        if (pInfo.userUids.includes(userInfo.userUid)) {
          return pInfo;
        }
      }
      return undefined;
    }, [businessPlan, userInfo]);

    const planUsers = React.useMemo(() => {
      if (planInfo) {
        return planInfo.userUids.map((userUid) => ({
          userUid,
          ...businessPlan.data.userInfo[userUid],
        }));
      }

      return [];
    }, [planInfo, businessPlan]);

    if (!planInfo) {
      return null;
    }

    return (
      <YStack gap={"$small"}>
        <Subtext>{planInfo.title}</Subtext>
        <UserAvatarGroupRaw
          businessPlan={businessPlan}
          users={planUsers}
          size={AvatarSize.Smaller}
          skipPadding
        />
      </YStack>
    );
  },
);
